class Accordion {

  constructor(el) {
    this.reducedMotion = window.matchMedia( `(prefers-reduced-motion: reduce)` ) === true || window.matchMedia( `(prefers-reduced-motion: reduce)` ).matches === true;

    this.el = el;

    this.summary = el.querySelector( 'summary' );
    this.button = el.querySelector( '.card-team__card .icon' );
    this.content = el.querySelector( '.accordion__content' );

    this.mode = el.getAttribute('data-mode');
    this.image = el.querySelector( '.card-team__image' );

    this.animationDuration = this.reducedMotion ? 0 : parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--animation-speed-slow' ).replace( /\D/g, '' ) );
    this.easingFunction = 'cubic-bezier(.1, .1, 0, 1)';
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener( 'click', (e) => this.onClick( e ) );
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if ( this.button ) {
      this.button.classList.toggle('active')
    }
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }
    const fadeOUt = [
      { opacity: "1" },
      { opacity: "0" },
    ];
    const zoomInOut = [
      { transform: "scale(1.1)" },
      { transform: "scale(1)" },
      { transform: "scale(1.1)" },
    ];

    if ( 'fade' != this.mode ) {
      this.animation = this.el.animate( {
        height: [startHeight, endHeight]
      }, {
        duration: this.animationDuration,
        easing: this.easingFunction
      } );
    }
    else {
      this.animation = this.content.animate(fadeOUt, {
        duration: this.animationDuration,
        easing: this.easingFunction
      } ),
      this.animation = this.image.animate(zoomInOut, {
        duration: this.animationDuration,
        easing: this.easingFunction
      } )
    }
    this.animation.onfinish = () => this.onAnimationFinish( false );
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame( () => this.expand() );
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    const fadeIn = [
      { opacity: "0" },
      { opacity: "1" },
    ];

    if ( 'fade' != this.mode ) {
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },

      {
        duration: this.animationDuration,
        easing: this.easingFunction
      } );
    }
    else {
      this.animation = this.content.animate(fadeIn,   {
        duration: this.animationDuration,
        easing: this.easingFunction
      })
    }

    this.animation.onfinish = () => this.onAnimationFinish( true );
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

const accordions = allAccordions => {
  if (!allAccordions) {
    return;
  }

  allAccordions.forEach( accordion => new Accordion( accordion ) );
};

export default accordions;
